import React from 'react';
import { ProductListSortOption } from '../../../../utils/productListSort';
import { CusProductListSortSectionProps } from '../../cus-product-list.data';

type SortLabelKey = 'sortRecommendedText' | 'sortByOptionPriceAsc' | 'sortByOptionPriceDesc';

const SORT_OPTIONS: { value: ProductListSortOption; labelKey: SortLabelKey }[] = [
    { value: 'recommended', labelKey: 'sortRecommendedText' },
    { value: 'price-asc', labelKey: 'sortByOptionPriceAsc' },
    { value: 'price-desc', labelKey: 'sortByOptionPriceDesc' }
];

export default function SortSection({ props, currentSort, onSortChange }: CusProductListSortSectionProps) {
    const { sortByDropdownLabel, sortRecommendedText, sortByOptionPriceAsc, sortByOptionPriceDesc } = props.resources;
    const [isCollapsed, setIsCollapsed] = React.useState(false);

    const labels: Record<SortLabelKey, string> = {
        sortRecommendedText,
        sortByOptionPriceAsc,
        sortByOptionPriceDesc
    };

    return (
        <section className='bs-product-list-filters__section bs-product-list-filters__section--sort'>
            <button
                type='button'
                className='bs-product-list-filters__section__title'
                onClick={() => setIsCollapsed(prev => !prev)}
                aria-expanded={!isCollapsed}
            >
                {sortByDropdownLabel}
                <span className='bs-product-list-filters__section__title__chevron' aria-hidden='true' />
            </button>
            <ul className={`bs-product-list-filters__list${isCollapsed ? ' --collapsed' : ''}`}>
                {SORT_OPTIONS.map(opt => (
                    <li key={opt.value} className='bs-product-list-filters__list__item'>
                        <label className='bs-product-list-filters__list__item__label'>
                            <span>{labels[opt.labelKey]}</span>
                            <input
                                type='radio'
                                name='plp-sort'
                                className='bs-product-list-filters__list__item__checkbox'
                                checked={currentSort === opt.value}
                                onChange={() => onSortChange(opt.value)}
                            />
                        </label>
                    </li>
                ))}
            </ul>
        </section>
    );
}
